import React from 'react';
import Icon from '@/app/components/Icon';
import Text from '@/app/components/Text';

function PromotionalTopBanner({
  promotionalBannerText = '',
  onClose = () => {},
}) {
  return (
    <div className="bg-titanwhite w-full flex justify-center py-6 lg:py-10 px-4 order-last lg:order-first">
      <div className="flex items-center gap-1">
        <Text
          type="sub_title"
          className="text-12 lg:text-16 text-richcarmine !font-encode-sans font-medium leading-14 lg:leading-20 tracking-[0.24px] lg:tracking-[0.32px]"
        >
          {promotionalBannerText}
        </Text>

        <Icon
          type="close"
          color="#49525E"
          className="size-[16px] lg:size-[24px] cursor-pointer"
          onClick={onClose}
        />
      </div>
    </div>
  );
}

export default PromotionalTopBanner;
